module.exports = __webpack_public_path__ + "static/home__who-we-are.87c775fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home__who-we-are.jpg
// module id = 510
// module chunks = 35783957827783